module.exports = __webpack_public_path__ + "img/benefit-logo-1.23534deb.svg";